<div class="wrapper">
  <header id="page-topbar">
    <div class="navbar-header">
      <div class="d-flex">
        <!-- LOGO -->
        <div class="navbar-brand-box" title="SesameWms System">
          <a class="logo logo-dark" routerLink="/#">
            <span class="logo-sm">
              <img src="assets/Layout/images/logo.svg" alt="" height="22">
            </span>
            <span class="logo-lg">
              <img src="assets/Layout/images/logo-dark.png" alt="" height="32" id="imgAppLogo">
            </span>
          </a>

          <a class="logo logo-light" routerLink="/#">
            <span class="logo-sm">
              <img src="assets/Layout/images/logo-light.svg" alt="" height="22">
            </span>
            <span class="logo-lg">
              <img src="assets/Layout/images/logo-light.png" alt="" height="19">
            </span>
          </a>
        </div>

        <button type="button" class="btn btn-sm px-3 font-size-16 d-lg-none header-item waves-effect waves-light" data-bs-toggle="collapse" data-bs-target="#topnav-menu-content">
          <i class="fa fa-fw fa-bars"></i>
        </button>


        <!-- App Search-->
      </div>
      <h4 class="mb-sm-0" id="h4pageheading">{{PageHeading === 'nEdit Dashboard' ? PageHeading : (PageHeading | titlecase)}}</h4>

      <div class="d-flex">
        <img src="assets/Layout/images/nExpressLogo.png" alt="" height="32" class="imgXpressLogo" *ngIf="expressflow=='true'">

        <img src="assets/Layout/images/ngrammr-logo.png" alt="" height="32" class="imgXpressLogo" id="imgnGrammr" *ngIf="grammrflow=='true'">

        <!--TopIcon Hide General Role-->
        <div class="dropdown d-inline-block d-lg-none ms-2" style="display:block !important" *ngIf="topIconHide=='false'">
          <button type="button" class="btn header-item noti-icon waves-effect" id="page-header-search-dropdown"
                  data-bs-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
            <i class="mdi mdi-magnify"></i>
          </button>
          <div class="dropdown-menu dropdown-menu-lg dropdown-menu-end p-0"
               aria-labelledby="page-header-search-dropdown">
            <form class="p-3">
              <div class="form-group m-0">
                <div class="input-group">
                  <input type="text" class="form-control" placeholder="Search ..." aria-label="Search input" id="txtQuickSearch">
                  <button class="btn btn-primary" type="submit" (click)="GetSearchData()"><i class="mdi mdi-magnify"></i></button>
                </div>
              </div>
            </form>
          </div>
        </div>

        <div class="dropdown d-inline-block" style="display:none !important">
          <button type="button" class="btn header-item waves-effect"
                  data-bs-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
            <img id="header-lang-img" src="assets/Layout/images/flags/us.jpg" alt="Header Language" height="16">
          </button>
          <div class="dropdown-menu dropdown-menu-end">
            <!-- item-->
            <a href="javascript:void(0);" class="dropdown-item notify-item language" data-lang="eng">
              <img src="assets/Layout/images/flags/us.jpg" alt="user-image" class="me-1" height="12"> <span class="align-middle">English</span>
            </a>
            <!-- item-->
            <a href="javascript:void(0);" class="dropdown-item notify-item language" data-lang="sp">
              <img src="assets/Layout/images/flags/spain.jpg" alt="user-image" class="me-1" height="12"> <span class="align-middle">Spanish</span>
            </a>
            <!-- item-->
            <a href="javascript:void(0);" class="dropdown-item notify-item language" data-lang="gr">
              <img src="assets/Layout/images/flags/germany.jpg" alt="user-image" class="me-1" height="12"> <span class="align-middle">German</span>
            </a>
            <!-- item-->
            <a href="javascript:void(0);" class="dropdown-item notify-item language" data-lang="it">
              <img src="assets/Layout/images/flags/italy.jpg" alt="user-image" class="me-1" height="12"> <span class="align-middle">Italian</span>
            </a>
            <!-- item-->
            <a href="javascript:void(0);" class="dropdown-item notify-item language" data-lang="ru">
              <img src="assets/Layout/images/flags/russia.jpg" alt="user-image" class="me-1" height="12"> <span class="align-middle">Russian</span>
            </a>
          </div>
        </div>

        <div class="dropdown d-none d-lg-inline-block ms-1" style="display:none !important">
          <button type="button" class="btn header-item noti-icon waves-effect"
                  data-bs-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
            <i class="bx bx-customize"></i>
          </button>
          <div class="dropdown-menu dropdown-menu-lg dropdown-menu-end">
            <div class="px-lg-2">
              <div class="row g-0">
                <div class="col">
                  <a class="dropdown-icon-item" href="#">
                    <img src="assets/Layout/images/brands/github.png" alt="Github">
                    <span>GitHub</span>
                  </a>
                </div>
                <div class="col">
                  <a class="dropdown-icon-item" href="#">
                    <img src="assets/Layout/images/brands/bitbucket.png" alt="bitbucket">
                    <span>Bitbucket</span>
                  </a>
                </div>
                <div class="col">
                  <a class="dropdown-icon-item" href="#">
                    <img src="assets/Layout/images/brands/dribbble.png" alt="dribbble">
                    <span>Dribbble</span>
                  </a>
                </div>
              </div>

              <div class="row no-gutters">
                <div class="col">
                  <a class="dropdown-icon-item" href="#">
                    <img src="assets/Layoutimages/brands/dropbox.png" alt="dropbox">
                    <span>Dropbox</span>
                  </a>
                </div>
                <div class="col">
                  <a class="dropdown-icon-item" href="#">
                    <img src="assets/Layout/images/brands/mail_chimp.png" alt="mail_chimp">
                    <span>Mail Chimp</span>
                  </a>
                </div>
                <div class="col">
                  <a class="dropdown-icon-item" href="#">
                    <img src="assets/Layout/images/brands/slack.png" alt="slack">
                    <span>Slack</span>
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="dropdown d-none d-lg-inline-block ms-1" style="display:none !important">
          <button type="button" class="btn header-item noti-icon waves-effect" data-bs-toggle="fullscreen">
            <i class="bx bx-fullscreen"></i>
          </button>
        </div>

        <div class="dropdown d-inline-block" *ngIf="topIconHide=='false'">
          <button type="button" class="btn header-item noti-icon waves-effect" id="page-header-notifications-dropdown"
                  data-bs-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
            <i class="bx bx-bell" id="ibellAnimate"></i>
            <span class="badge bg-danger rounded-pill" id="spCount">{{notificationCount}}</span>
          </button>
          <div class="dropdown-menu dropdown-menu-lg dropdown-menu-end p-0"
               aria-labelledby="page-header-notifications-dropdown">
            <div class="p-3">
              <div class="row align-items-center">
                <div class="col">
                  <h6 class="m-0" key="t-notifications"> Notifications </h6>
                </div>
                <div class="col-auto">
                  <a class="small" key="t-view-all" [routerLink]='["/notification"]'> View All</a>
                </div>
              </div>
            </div>
            <span id="spUpdateNotification" (click)="updateNotification()" style="display:none">updateNotification</span>
            <div data-simplebar style="max-height: 230px;">
              <div id="divNotification">
              </div>
            </div>
            <div class="p-2 border-top d-grid">
              <a class="btn btn-sm btn-link font-size-14 text-center" [routerLink]='["/notification"]'>
                <i class="mdi mdi-arrow-right-circle me-1"></i> <span key="t-view-more">View More..</span>
              </a>
            </div>
          </div>
        </div>

        <!--Bio-Med Production Data-->
        <div *ngIf="biomedPrdData" title="Production Data">
          <button type="button" class="btn header-item noti-icon waves-effect"
                  aria-haspopup="true" aria-expanded="false" (click)="ShowPrdReport()">
            <i class="fa fa-folder-open"></i>
          </button>
        </div>

        <!--Change Publisher and Role -->
        <div id="accessmenulist" *ngIf="multiPublist=='1'">
          <button type="button" class="btn header-item noti-icon waves-effect"
                  aria-haspopup="true" aria-expanded="false" (click)="GetAccessRole()">
            <i class="fa fa-users"></i>
            <span class="badge bg-danger rounded-pill"></span>
          </button>
        </div>

        <div class="modal" id="AccessModal" role="dialog" [style.display]="showAccessModal ? 'block' : 'none'" *ngIf="multiPublist=='1'">
          <div class="modal-dialog">
            <div class="modal-content" id="divChangeRoles">
              <!-- Modal Header -->
              <div class="modal-header">
                <h4 class="modal-title">{{AccessModaltitle}}</h4>
                <button type="button" class="close" data-dismiss="modal" (click)="HideAccessModal()">&times;</button>
              </div>
              <div class="modal-body">
                <div id="divChangeRole" class="divRole">

                  <div>
                    <label>Current Publisher</label>
                  </div>
                  <div title="Click to change">
                    <select id="ddlPubsListAM" class="form-select ddlselect">
                      <option value=0>Select</option>
                      <option *ngFor="let item of pubsList_AccessModal" value={{item.ID}} [selected]="item.ID==currentPubsId">
                        {{item.PublisherCode}}
                      </option>
                    </select>
                  </div>

                  <div>
                    <label>Current Role</label>
                  </div>
                  <div title="Click to change">
                    <select id="ddlRolesListAM" class="form-select ddlselect">
                      <option value=0>Select</option>
                      <option *ngFor="let item of rolesList_AccessModal" value={{item.RoleID}} [selected]="item.RoleID==currentRolesId">
                        {{item.RoleName}}
                      </option>
                    </select>
                  </div>
                </div>
              </div>
              <!-- Modal footer -->
              <div class="modal-footer">
                <button type="button" class="btn btn-outline-danger waves-effect waves-light" data-dismiss="modal" (click)="HideAccessModal()">Close</button>
                <button type="button" class="btn btn-outline-success waves-effect waves-light" (click)="ChangeAccessPubOrRole()">Update</button>
              </div>
            </div>
          </div>
        </div>


        <div class="dropdown d-inline-block">
          <button type="button" class="btn header-item waves-effect" id="page-header-user-dropdown"
                  data-bs-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
            <img id="imgUserLogo" class="rounded-circle header-profile-user imgProfile" src="../../assets/Images/userLogo.jpg" alt="Header Avatar">
            <span class="d-none d-xl-inline-block ms-1" key="t-henry">{{LoginName}}</span>
            <i class="mdi mdi-chevron-down d-none d-xl-inline-block"></i>
          </button>
          <div class="dropdown-menu dropdown-menu-end">
            <!-- item-->
            <a class="dropdown-item" [routerLink]='["/user-profile"]' *ngIf="topIconHide=='false'">
              <i class="bx bx-user font-size-16 align-middle me-1"></i>
              <span key="t-profile">Profile</span>
            </a>
            <a class="dropdown-item" href="#" style="display:none !important">
              <i class="bx bx-wallet font-size-16 align-middle me-1"></i>
              <span key="t-my-wallet">My Wallet</span>
            </a>
            <a class="dropdown-item d-block" href="#" style="display:none !important">
              <span class="badge bg-success float-end">11</span><i class="bx bx-wrench font-size-16 align-middle me-1"></i>
              <span key="t-settings">Settings</span>
            </a>
            <a class="dropdown-item" href="#" style="display:none">
              <i class="bx bx-lock-open font-size-16 align-middle me-1"></i>
              <span key="t-lock-screen">Lock screen</span>
            </a>
            <div class="dropdown-divider"></div>
            <a class="dropdown-item text-danger" (click)="UserLogout()">
              <i class="bx bx-power-off font-size-16 align-middle me-1 text-danger"></i> <span key="t-logout">Logout</span>
            </a>
          </div>
        </div>
      </div>
    </div>
  </header>
  <!-- Navbar -->

  <div class="modal" id="PopupNotification" role="dialog" [style.display]="showPopUpNotification ? 'block' : 'none'">
    <div class="modal-dialog modal-lg">
      <div class="modal-content" id="divPopupNotification">
        <!-- Modal Header -->
        <div class="modal-header">
          <h4 class="modal-title">Notification</h4>
          <!--<button type="button" class="close" data-dismiss="modal" (click)="HidePopUpNotification()">&times;</button>-->
        </div>
        <div class="modal-body">
          <!--<div id="divChangeRole" class="divRole">-->
          <div class="row">
            -g
            <div class="form-group col-sm-12">

              <!--<label for="txtPopUpNotification">{{PopupNotificationTitle}}</label>-->
              <!--<textarea type="text" class="form-control" id="txtPopUpNotification" rows="7" autocomplete="off"> </textarea>-->
              <table id="tblPopUpNotification" class="table" Style="width:100%">
                <thead>
                  <tr>
                    <th>#</th>
                    <th>Acronym</th>
                    <th>Title</th>
                    <th>Description</th>
                  </tr>
                </thead>
                <tbody></tbody>
              </table>
            </div>
          </div>
          <!-- </div> -->
        </div>
        <!-- Modal footer -->
        <div class="modal-footer">
          <!--<button type="button" class="btn btn-outline-danger waves-effect waves-light" data-dismiss="modal" (click)="HidePopUpNotification()">Close</button>-->
          <button type="button" class="btn btn-outline-success waves-effect waves-light" (click)="ReadPopUpNotification()">Mark as Read</button>
        </div>
      </div>
    </div>
  </div>

  <div class="topnav" *ngIf="hideTopMenu=='false'">
    <div class="container-fluid">
      <nav class="navbar navbar-light navbar-expand-lg topnav-menu">
        <div class="collapse navbar-collapse" id="topnav-menu-content">
          <ul class="navbar-nav">
            <li class="nav-item dropdown" *ngFor="let link of links" (click)="treeviewinit()">
              <a class="nav-link arrow-none" id="topnav-{{ link.MenuName }}" role="button" *ngIf="link.MenuType=='Parent'">
                <i class="me-2 nav-icon {{link.Icon}}"></i><span key="t-dashboards">{{ link.MenuName }}</span><div class="arrow-down"></div>
              </a>
              <div class="dropdown-menu" aria-labelledby="topnav-{{ link.MenuName }}">
                <div *ngFor="let link1 of links1">
                  <a routerLink="/{{link1.LinkPath}}" class="dropdown-item" title="{{link1.Description}}" *ngIf="link1.MenuType == 'Child' && link1.IsMenuItem == '1' && link.MenuID == link1.ParentMenu">
                    <i class="me-2 {{link1.Icon}} nav-icon"></i>
                    {{link1.MenuName}}
                  </a>
                </div>
              </div>
            </li>
          </ul>
        </div>
      </nav>
    </div>
  </div>

  <div class="main-content">
    <div class="page-content">
      <div class="container-fluid">
        <div class="row">
          <router-outlet></router-outlet>
        </div>
      </div>
    </div>
    <!--<footer class="footer" style="left:0 !important">
      <div class="container-fluid">
        <div class="row">
          <div class="col-sm-12">
            <strong>
              Copyright &copy; {{currentYear}}
              <span>SesameWms - AAAS</span>.
            </strong>
            All rights reserved.
          </div>
        </div>
      </div>
    </footer>-->
  </div>
</div>

<!--<div class="row footerbt">
  <span> Copyright &copy; {{currentYear}} SesameWms - AAAS  All rights reserved.</span>.
</div>-->
<!-- Right Sidebar -->
<!--<div class="right-bar">
  <div data-simplebar class="h-100">
    <div class="rightbar-title d-flex align-items-center px-3 py-4">

      <h5 class="m-0 me-2">Settings</h5>

      <a href="javascript:void(0);" class="right-bar-toggle ms-auto">
        <i class="mdi mdi-close noti-icon"></i>
      </a>
    </div>-->
<!-- Settings -->
<!--<hr class="mt-0" />
  <h6 class="text-center mb-0">Choose Layouts</h6>

  <div class="p-4">
    <div class="form-check form-switch mb-3">
      <input class="form-check-input theme-choice" type="checkbox" id="light-mode-switch" checked>
      <label class="form-check-label" for="light-mode-switch">Light Mode</label>
    </div>
    <div class="form-check form-switch mb-3">
      <input class="form-check-input theme-choice" type="checkbox" id="dark-mode-switch">
      <label class="form-check-label" for="dark-mode-switch">Dark Mode</label>
    </div>

  </div>

</div>-->
<!-- end slimscroll-menu-->
<!--</div>-->
<!-- /Right-bar -->

<button type="button" id="btnNotifyList" (click)="loadPopupNotification()" style="display:none">Show</button>
<button type="button" id="btnShowCO" (click)="ShowCO()" style="display:none">Show</button>
<div id="divColumnOption" class="modal" [style.display]="showModalCO ? 'block' : 'none'">
  <div class="modal-dialog modal-sm">
    <div class="modal-content">
      <div class="modal-header">
        <h4 class="modal-title">Column Options</h4>
        <button type="button" class="close" data-dismiss="modal" (click)="hideCO()">×</button>
      </div>
      <div class="modal-body" id="divCOBody">
        <div class="row">
          <div class="col-sm-12" style="overflow:auto" id="divCOList">
            <div class="form-group" id="divColumnsList">

            </div>
          </div>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-outline-warning waves-effect waves-light" (click)="UpdateCO('Reset')">Reset</button>
          <button type="button" class="btn btn-outline-danger waves-effect waves-light" data-dismiss="modal" (click)="hideCO()">Close</button>
          <button type="button" class="btn btn-outline-info waves-effect waves-light" id="btnCOApply" (click)="UpdateCO('Apply')">Apply</button>
        </div>
      </div>
    </div>
  </div>
</div>

<div class="modal" id="myBioMedModal" [style.display]="showPrdModal ? 'block' : 'none'">
  <div class="modal-dialog modal-xl custome-modal">
    <div class="modal-content">
      <div class="modal-header">
        <h4 class="modal-title">Bio & Med - Production Report</h4>
        <div class="col-2">
          <input type="date" name="Date" class="form-control float-right" id="TxtBioMedDate" autocomplete="off">
        </div>
        <div class="col-2">
          <button type="button" class="btn btn-info waves-effect waves-light" (click)="GetProductionData()">Search</button>
        </div>

        <button type="button" class="close" data-dismiss="modal" (click)="hidePrd()">&times;</button>
      </div>

      <div class="model-body">

        <div class="row col">

          <div id="divPrdDataList"></div>

          <div id="LoadingImagePopup1">
            <img src="assets/Images/loader.gif" class="imgLoadimg" alt="Loading" />
          </div>

        </div>
      </div>
      <br /> <br /> <br />
    </div>
  </div>
</div>
